import moment from 'moment';
import 'moment/locale/es';
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ResponsiveContext } from '../../contexts/ResponsiveContext';
import Message from '../LoadingError/Error';
import Loading from '../LoadingError/Loading';

const Orders = ({ orders, loadingOrders, ordersError }) => {
  moment.locale('es');

  const { is1000 } = useContext(ResponsiveContext);
  return (
    <div className=' d-flex justify-content-center align-items-center flex-column'>
      {loadingOrders ? (
        <Loading />
      ) : ordersError ? (
        <Message variant='alert-danger'>{ordersError}</Message>
      ) : (
        <>
          {orders.length === 0 ? (
            <div
              className={`col-12 alert alert-info text-center ${
                is1000 ? '' : 'mt-5'
              }`}
            >
              No tienes ningún pedido
              <Link
                className='btn btn-success mx-2 px-3 py-2'
                to='/'
                style={{
                  fontSize: '12px',
                }}
              >
                EMPIEZA A COMPRAR
              </Link>
            </div>
          ) : (
            <div className={`table-responsive ${is1000 ? '' : 'mt-5'}`}>
              <table className='table'>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>ESTADO</th>
                    <th>FECHA</th>
                    <th>TOTAL</th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map((order) => (
                    <tr
                      className={`${
                        order.isPaid ? 'alert-success' : 'alert-danger'
                      }`}
                      key={order._id}
                    >
                      <td>
                        <a href={`/order/${order._id}`} className='link'>
                          {order._id.substr(-6, 6)}
                        </a>
                      </td>
                      <td>{order.isPaid ? <>Pagado</> : <>No Pagado</>}</td>
                      <td>
                        {order.isPaid
                          ? moment(order.paidAt).calendar()
                          : moment(order.createdAt).calendar()}
                      </td>
                      <td>
                        {order?.totalPrice.toString().replace('.', ',')}
                        {order?.totalPrice
                          .toString()
                          .replace('.', ',')
                          .split(',')[1]
                          ? order?.totalPrice
                              .toString()
                              .replace('.', ',')
                              .split(',')[1].length === 1
                            ? '0'
                            : ''
                          : ',00'}{' '}
                        €
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default Orders;
